import { render, staticRenderFns } from "./repsDetails.vue?vue&type=template&id=fcbd3944"
import script from "./repsDetails.vue?vue&type=script&lang=js"
export * from "./repsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports